import React, { useMemo } from 'react';
import { cleanMultiSelectQueryRequest } from '../util/cleanMultiSelectQueryRequest';
import { dashboardFilterValidation } from '../validation/dashboardFilterValidation';
import { Form, Formik } from 'formik';
import { Grid } from '@zillow/constellation';
import { InternalContactsFilter } from '../filterFields/InternalContactsFilter';
import { ClientCompaniesFilter } from '../filterFields/ClientCompaniesFilter';
import { ClosingDateFilter } from '../filterFields/ClosingDateFilter';
import { TransactionTypeFilter } from '../filterFields/TransactionTypeFilter';
import { StatusFilter } from '../filterFields/StatusFilter';
import { StateFilter } from '../filterFields/StateFilter';
import { FilterButtonsRow } from '../FilterFormButtonRow';
import { IOrderParams } from '../../../../API/pcDashboard/getOrderAsync';
import { convertKebabToSlash } from '../util/conversions';
import { CityFilter } from '../filterFields/CityFilter';
import { ZipCodeFilter } from '../filterFields/ZipCodeFilter';
import { LenderCompaniesFilter } from '../filterFields/LenderCompaniesFilter';
import { TagsFilter } from '../filterFields/TagsFilter';
import { CreationDateFilter } from '../filterFields/CreationDateFilter';
import { SettlementAgentsFilter } from '../filterFields/SettlementAgentsFilter';
import { UnderwritersFilter } from '../filterFields/UnderwritersFilter';

const useGetInitialValues = (queryObject: IOrderParams) => {
  return useMemo(() => {
    const { closingDateStart, closingDateEnd, createdAtStart, createdAtEnd, ...rest } = queryObject;
    const closingStart = closingDateStart ? convertKebabToSlash(closingDateStart) : '';
    const closingEnd = closingDateEnd ? convertKebabToSlash(closingDateEnd) : '';
    const creationStart = createdAtStart ? convertKebabToSlash(createdAtStart) : '';
    const creationEnd = createdAtEnd ? convertKebabToSlash(createdAtEnd) : '';
    return {
      closingDateStart: closingStart,
      closingDateEnd: closingEnd,
      createdAtStart: creationStart,
      createdAtEnd: creationEnd,
      ...rest,
    };
  }, [queryObject]);
};

export const DashboardFilterForm: React.FC<{
  queryObject: IOrderParams;
  setQueryObject: (queryObject: IOrderParams) => void;
}> = ({ queryObject, setQueryObject }) => {
  const initialValues = useGetInitialValues(queryObject);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        const cleanedValues = { ...cleanMultiSelectQueryRequest(values), pageNumber: 0, pageSize: 20 };
        setQueryObject(cleanedValues);
      }}
      validationSchema={dashboardFilterValidation}
      enableReinitialize
    >
      <Form>
        <Grid
          display={'grid'}
          gridTemplateColumns={{
            default: 'repeat(2, minmax(140px, 1fr)) minmax(360px, 1fr) repeat(3, minmax(140px, 1fr))',
            lg_lte: 'repeat(2, minmax(140px, 1fr)) minmax(360px, 1fr)',
          }}
          gap={'sm'}
          alignItems={'stretch'}
        >
          <InternalContactsFilter />
          <ClientCompaniesFilter />
          <ClosingDateFilter />
          <TransactionTypeFilter />
          <StatusFilter />
          <TagsFilter />
          <LenderCompaniesFilter />
          <CreationDateFilter />
          <CityFilter />
          <StateFilter />
          <ZipCodeFilter />
          <SettlementAgentsFilter />
          <UnderwritersFilter />
        </Grid>
        <FilterButtonsRow />
      </Form>
    </Formik>
  );
};
